import { useCallback, useReducer } from "react";

interface ChatWidgetState {
  isChatPanelOpen: boolean;
}

type ChatWidgetAction = { type: "openPanel" } | { type: "closePanel" };

const chatWidgetInitialState: ChatWidgetState = {
  isChatPanelOpen: false,
};

const chatWidgetReducer = (
  state: ChatWidgetState,
  action: ChatWidgetAction,
): ChatWidgetState => {
  switch (action.type) {
    case "openPanel":
      return { ...state, isChatPanelOpen: true };
    case "closePanel":
      return { ...state, isChatPanelOpen: false };
    default:
      return state;
  }
};

export const useChatWidgetState = () => {
  const [state, dispatch] = useReducer(chatWidgetReducer, chatWidgetInitialState);

  const openPanel = useCallback(() => dispatch({ type: "openPanel" }), []);
  const closePanel = useCallback(() => dispatch({ type: "closePanel" }), []);

  return { isChatPanelOpen: state.isChatPanelOpen, openPanel, closePanel };
};
